// Client for POST /api/pa/tools/execute (PA-2a).

import { getCapabilityOverrides } from "@/lib/capabilities/capabilityStorage";
import { PA_DEV_IMPERSONATION_HEADER } from "@/lib/personalAssistant/paDevImpersonationHeader";
import type { AssistMode } from "@/lib/personalAssistant/paAssistModeStorage";
import type { PaToolId } from "@/lib/personalAssistant/paToolCatalog";
import type { PaToolExecuteResult } from "@/lib/personalAssistant/paThreadTypes";

export type PaToolExecuteRequest = {
  token: string;
  organizationId: string | null;
  assistMode: AssistMode;
  impersonationActive?: boolean;
  action: "confirm" | "cancel";
  proposalId: string;
  toolId: PaToolId;
  arguments: Record<string, unknown>;
  assistantMessageId: string;
};

export async function executePaTool(req: PaToolExecuteRequest): Promise<PaToolExecuteResult> {
  const headers: Record<string, string> = {
    Authorization: `Bearer ${req.token}`,
    "Content-Type": "application/json",
  };
  if (req.organizationId) {
    headers["x-workspace-organization-id"] = req.organizationId;
  }
  if (req.impersonationActive) {
    headers[PA_DEV_IMPERSONATION_HEADER] = "true";
  }

  const resp = await fetch("/api/pa/tools/execute", {
    method: "POST",
    headers,
    body: JSON.stringify({
      action: req.action,
      proposalId: req.proposalId,
      toolId: req.toolId,
      arguments: req.arguments,
      assistantMessageId: req.assistantMessageId,
      assistMode: req.assistMode,
      capabilityOverrides: getCapabilityOverrides(),
    }),
  });

  const payload = (await resp.json().catch(() => null)) as PaToolExecuteResult | null;
  if (!resp.ok) {
    return { ok: false, error: payload?.error ?? `Execute failed (${resp.status})` };
  }
  return payload ?? { ok: true };
}
